module.exports = __webpack_public_path__ + "static/img/Oak Chocolate.195224a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Oak Chocolate.jpg
// module id = UEoc
// module chunks = 0